import { UATConstants } from 'src/Common/Models/UATConstants';
import { ITenantUIConfig, TenantProvider } from 'src/tenantConfig/interface/index.ts';
import { AzureISVFilterConfig } from './filters/AzureISVFilterConfig';
import { AzureSponsorshipConstants } from 'src/manageAction/models/AzureSponsorshipConst';

export const AzureISVTenantConfig: Partial<ITenantUIConfig> = {
  nodeName: [UATConstants.PlaceholdersAndTitles.AzureSponsorshipISV],
  provider: TenantProvider.ARTEMIS,
  TenantExperience: true,
  FeatureConfig: {
    SensitiveInfoValidation: false,
    SensativeInfoErrorCount: false,
    AttachmentConfigurations: [],
    Navigation: {
      GlobalSearch: true,
      Copilot: true,
      Analytics: false,
      RequestAccess: true,
      Settings: true,
      Notifications: true,
      Help: true,
    },
    Hub: {
      Filter: true,
      FilterConfig: AzureISVFilterConfig,
      AreaPath: [],
      Title: UATConstants.TenantTitles.AzureISV,
      ADOTitle: UATConstants.TenantADOText.AzureISV,
      Create: [
        {
          Text: UATConstants.CreateActionMenuTitle.CreateAzureISVRequest,
          Key: UATConstants.CreateActionMenuKey.CreateAzureISVRequest,
          NodeName: '',
        },
      ],
      Download: true,
      RelatedItem: true,
      // BulkUpload: true,
      //   DownloadTemplate: true,
      // DownloadTemplateConfig: {
      //   tenantToolName: 'azureIsv',
      //   title: UATConstants.PlaceholdersAndTitles.AzureSponsorshipISV,
      //   excelColumnSequence: {
      //     'Title': 1,
      //     'Assigned Team': 2,
      //     'Action Owner Group': 3,
      //     'Action Owner': 4,
      //     'Requestors': 5,
      //     'Meeting Type': 6,
      //     'Meeting SubType': 7,
      //     'Region(s)': 8,
      //     'Areas/SMC Region': 9,
      //     'Sub-region/SMC OU': 10,
      //     'Problem Details': 11,
      //     'Business Impact': 12,
      //     'Priority': 13,
      //     'Due Date': 14,
      //     'Contributor 1': 15,
      //     'Contributor 2': 16,
      //     'Solution Area': 17,
      //     'Status Update': 18,
      //   },
      // },
      // Download: true,
      Email: true,
      LocalSearch: true,
      ColumnOptions: false,
      ColumnOptionsConfig: [],
      SplitMode: false,
      BulkEdit: false,
      BulkEditConfig: [],
      CreateRAID: false,
    },
    ManageAction: {
      NewExperience: true,
      MandateFormPickers: [
        { formFieldName: 'assignedTo', formFieldLabel: UATConstants.PlaceholdersAndTitles.ActionOwner, apiFieldName: 'assignedto' },
        { formFieldName: 'emailsToCC', formFieldLabel: AzureSponsorshipConstants.PlaceholdersAndTitles.EmailsToCC, apiFieldName: 'EmailsToCC' },
      ],
      Header: {
        Tags: true,
        Actions: {
          Follow: true,
          Email: true,
          CopyLink: true,
        },
      },
      Tabs: {
        TechnicalFeedback: false,
        RelatedItems: {
          showRelatedTab: true,
          showTFTCreated: true,
        },
        Attachments: true,
        History: true,
      },
      Panes: {
        CopilotInsights: {
          CustomerInsights: false,
          DiscussionInsights: false,
        },
        StatusUpdate: true,
        ClosureStatement: true,
        Discussion: true,
        Tasks: false,
        EmailConversation: false,
      },
    },
    ManageView: {
      showAddViewButton: true,
      showAddFolderButton: true,
      isArtemisIntegrationEnabled: true,
      showCommandBar: true,
      showPreviewFeatureMessageBar: false,
      showSelectFields: false,
      defaultViewId: '0d7155cb-83ee-45f9-8168-8ab7355f50d9',
      systemViewsFolderId: 'd915e8b3-a561-49ba-bc24-991acb291159',
      sharedViewsFolderId: '789df76a-fb19-4409-b8b2-0a6954d90e0a',
    },
  },
};

// Generated by GitHub Copilot | Updated on: 2026-08-24 | 4 lines modified | Removed string fields from picker validation
